import PropTypes from 'prop-types'
import React from 'react'

const weekDays = {
  Mon: 'Montag',
  Tue: 'Dienstag',
  Wed: 'Mittwoch',
  Thu: 'Donnerstag',
  Fri: 'Freitag',
  Sat: 'Samstag',
  Sun: 'Sonntag',
}

const months = {
  Jan: 'Januar',
  Feb: 'Februar',
  Mar: 'März',
  Apr: 'April',
  May: 'Mai',
  Jun: 'Juni',
  Jul: 'Juli',
  Aug: 'August',
  Sep: 'September',
  Oct: 'Oktobar',
  Nov: 'November',
  Dec: 'Dezember',
}

const WEEKDAY_INDEX = 0
const MONTH_INDEX = 1
const DAY_INDEX = 2
const YEAR_INDEX = 3
const TIME_INDEX = 4

function parseDate(dateStr) {

  // this cannot be simplified as new Date(undefined) !== new Date()
  const dateArray = (dateStr ? new Date(dateStr.replace(/(-\d{1,2})\s+(\d{1,2}:)/, '$1T$2')) : new Date()).toString().split(' ')
  return {
    weekDay: weekDays[dateArray[WEEKDAY_INDEX]],
    day: dateArray[DAY_INDEX] * 1,
    month: months[dateArray[MONTH_INDEX]],
    year: dateArray[YEAR_INDEX] * 1,
    time: dateArray[TIME_INDEX]
  }
}

function renderDate(dateObj) {
  const {
    weekDay,
    month,
    day,
    year,
  } = dateObj

  let children = `${weekDay}, ${day}. ${month} ${year}`

  const today = parseDate()

  if (
    today.month === month
    && today.year === year
  ) {

    if (today.day === day) {
      children = 'Heute'
    }
    else if ((today.day - 1) === day) {
      children = 'Gestern'
    }
    else if ((today.day - 2) === day) {
      children = 'Vorgestern'
    }
  }

  return (
    <span className="df-date">
      {children}
    </span>
  )
}

function renderCompleteDate({
  day, month, year, time
}) {
  return `${day}. ${month} ${year}, ${time} Uhr`
}

function renderTime(dateObj) {
  return (
    <span className="df-time">
      {dateObj.time}
      {' '}
      Uhr
    </span>
  )
}

export default function DateFormatter({ date }) {
  const dateObj = parseDate(date)
  return (
    <span title={renderCompleteDate(dateObj)}>
      {renderDate(dateObj)}
      ,
      {renderTime(dateObj)}
    </span>
  )
}

DateFormatter.propTypes = {
  date: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/shared/components/DateFormatter.js